import { render } from "./ChangeRequestList.vue?vue&type=template&id=02e978d0&scoped=true"
import script from "./ChangeRequestList.vue?vue&type=script&lang=js"
export * from "./ChangeRequestList.vue?vue&type=script&lang=js"

import "./ChangeRequestList.vue?vue&type=style&index=0&id=02e978d0&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02e978d0"]])

export default __exports__